export default __webpack_public_path__ + "static/media/Questionnaire_Vanquis.1e178b84.pdf";